import { queryOptions } from '@tanstack/react-query'
import { apiGet, unwrap } from '@/shared/api'
import type { Employee } from '../model/schema'
import { type EmployeeDto, toEmployee } from './mappers'

export const employeeKeys = {
  all: ['employees'] as const,
  list: () => [...employeeKeys.all, 'list'] as const,
  me: () => [...employeeKeys.all, 'me'] as const,
  detail: (id: string) => [...employeeKeys.all, 'detail', id] as const,
  overview: () => [...employeeKeys.all, 'overview'] as const,
  projects: (id: string) => [...employeeKeys.all, 'projects', id] as const,
}

export const employeesQueryOptions = queryOptions({
  queryKey: employeeKeys.list(),
  queryFn: async (): Promise<Employee[]> => {
    const list = unwrap<EmployeeDto[]>(await apiGet('/employees')) ?? []
    return list.map(toEmployee)
  },
})

export const meQueryOptions = queryOptions({
  queryKey: employeeKeys.me(),
  queryFn: async (): Promise<Employee> =>
    toEmployee(unwrap<EmployeeDto>(await apiGet('/employees/me'))),
})

// Деталь произвольного сотрудника (страница профиля).
export function employeeQueryOptions(id: string) {
  return queryOptions({
    queryKey: employeeKeys.detail(id),
    queryFn: async (): Promise<Employee> =>
      toEmployee(unwrap<EmployeeDto>(await apiGet(`/employees/${id}`))),
  })
}

// Проекты, где сотрудник закреплён (id). Имена резолвятся consumer'ом по уже
// загружаемому списку проектов.
export function employeeProjectsQueryOptions(id: string) {
  return queryOptions({
    queryKey: employeeKeys.projects(id),
    queryFn: async (): Promise<string[]> =>
      unwrap<string[]>(await apiGet(`/employees/${id}/projects`)) ?? [],
  })
}
